import * as React from 'react';
import { useRef } from 'react';
import lowerCase from 'lodash/lowerCase';

import { Pluralize, Tooltip } from 'components/common';
import useEntityCollectionStatus from 'collections/hooks/useEntityCollectionStatus';
import { getValuesFromGRN } from 'logic/permissions/GRN';
import TitleCell from 'collections/components/EntitiesList/cells/TitleCell';

type Props = {
  entityId: string;
  entityType: string;
};

const SharedEntityCollectionCell = ({ entityId, entityType }: Props) => {
  const { id } = getValuesFromGRN(entityId);
  const { data, isFetching, isError } = useEntityCollectionStatus(entityId, id);
  const count = data?.length || 0;
  const isDisabled = count === 0;
  const spanRef = useRef();

  if (isFetching || isError) {
    return null;
  }

  const label = (
    <span>
      This {lowerCase(entityType)} is shared through {count}{' '}
      <Pluralize value={count} plural="collections" singular="collection" />.
    </span>
  );

  return (
    <td>
      <Tooltip withArrow position="right" label={label} disabled={isDisabled}>
        <span ref={spanRef}>
          {count > 0 && <TitleCell name={data[0].title} type="collection" id={data[0].id} />}
          {count > 1 && <span>{` (+${count - 1} more)`}</span>}
        </span>
      </Tooltip>
    </td>
  );
};

export default SharedEntityCollectionCell;
